import { PARAM_MEMBER_SLUG } from './constants';

export const buildLink = (template, memberSlug) => template.replace(PARAM_MEMBER_SLUG, memberSlug);
